<div [id]="chartdiv_id" class="doubleLineChart"></div>